import type React from 'react';
import type { ReactNode } from 'react';

import { cn } from '@change/ds-utils';

type Props = Readonly<{
	children: ReactNode;
	className?: string;
	// eslint-disable-next-line @typescript-eslint/naming-convention
	'data-qa': string;
}>;

/** The rounded panel with the light three-stop gradient background that holds a section's cards or columns. */
export const GradientPanel: React.FC<Props> = ({ children, className, 'data-qa': dataQa }) => {
	return (
		<div className={cn('bg-gradient-background-light-2 rounded-2xl p-7 md:p-10', className)} data-qa={dataQa}>
			{children}
		</div>
	);
};
